module.exports = __webpack_public_path__ + "52eb0b5043e6dbbc032d73db81f2fcf6.svg";